import React from "react";

import "./Navbar.scss";
import authService from "../../../auth/AuthService";

const Navbar = () => {
  return (
    <nav>
      <div className="navbar">
        <a href="/" className="navbar__logo">
          <svg width="102" height="16" viewBox="0 0 102 16" fill="none">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.09832 13.4092C8.0119 13.4092 8.72967 13.2298 9.25174 12.871C9.77381 12.5122 10.0348 11.9741 10.0348 11.249V11.2042C10.0348 10.5315 9.77381 10.0083 9.26628 9.64208C8.75143 9.27576 7.96114 9.08896 6.9098 9.08896H2.66097V13.4092H7.09832ZM6.31526 6.74942C7.18533 6.74942 7.88139 6.57004 8.40343 6.21874C8.92551 5.86744 9.18646 5.32928 9.18646 4.61174V4.56689C9.18646 3.93903 8.9545 3.44572 8.50493 3.09442C8.04815 2.74312 7.38109 2.56374 6.51103 2.56374H2.66097V6.74942H6.31526ZM0 0.112117H6.84455C8.5992 0.112117 9.92605 0.575533 10.8324 1.50984C11.5139 2.21243 11.8547 3.08694 11.8547 4.11842V4.16326C11.8547 4.64163 11.7894 5.06767 11.6662 5.43392C11.5429 5.80017 11.3835 6.12158 11.1949 6.39813C10.9992 6.67468 10.7671 6.92134 10.4989 7.13062C10.2306 7.33991 9.96234 7.5193 9.68677 7.66878C10.1363 7.83322 10.5424 8.02752 10.9121 8.24432C11.2819 8.46104 11.601 8.72272 11.8619 9.02168C12.1303 9.32064 12.3405 9.67192 12.4783 10.083C12.6233 10.4866 12.6958 10.9575 12.6958 11.5032V11.548C12.6958 12.2506 12.558 12.8785 12.2897 13.4166C12.0215 13.9548 11.6444 14.4033 11.1442 14.7695C10.6511 15.1283 10.0565 15.4049 9.36054 15.5918C8.66447 15.7786 7.88864 15.8758 7.04757 15.8758H0V0.112117ZM28.0525 7.91544C29.0169 7.91544 29.7854 7.67626 30.351 7.20537C30.9238 6.73448 31.2066 6.0842 31.2066 5.27696V5.23211C31.2066 4.37255 30.9311 3.72227 30.3727 3.28128C29.8217 2.83282 29.0386 2.61606 28.0308 2.61606H24.1154V7.92292H28.0525V7.91544ZM21.4545 0.112117H28.2628C29.2199 0.112117 30.0755 0.254132 30.815 0.530686C31.5546 0.80724 32.1781 1.19591 32.6712 1.68922C33.0772 2.12274 33.389 2.62353 33.6065 3.19906C33.8241 3.76712 33.9328 4.40245 33.9328 5.0901V5.13494C33.9328 5.77775 33.8385 6.36075 33.6573 6.8765C33.476 7.39223 33.2223 7.84817 32.9032 8.25176C32.5842 8.64792 32.1999 8.98432 31.7576 9.26088C31.3154 9.53736 30.8223 9.75416 30.2858 9.90368L34.4113 15.8683H31.2501L27.487 10.382H27.4435H24.1154V15.8683H21.4545V0.112117ZM49.536 3.3037C46.9258 9.58224 46.7373 10.1204 44.3663 15.8534H41.6183L48.3396 0H50.8266L57.5479 15.8608H54.7129C52.3927 10.1877 52.0882 9.40288 49.536 3.3037ZM65.8643 0.112117H68.7211L73.3687 7.55667L78.0163 0.112117H80.8731V15.8608H78.2121V4.56689L73.3904 11.989H73.3034L68.5253 4.61174V15.8608H65.8643V0.112117ZM90.5021 0.112117H101.805V2.60858H93.1625V6.65974H100.819V9.15624H93.1625V13.3643H101.914V15.8608H90.5021V0.112117Z"
              fill="#222222"
            />
          </svg>
        </a>
        <ul className="navbar__right">
          <li>
            <a className="link-item" href="/dashboard">
              Dashboard
            </a>
          </li>
          <li>
            <a className="link-item" href="/users">
              Users
            </a>
          </li>
          <li>
            <a className="link-item" href="/campaigns">
              Campaigns
            </a>
          </li>
          <li>
            <a className="link-item active" href="/prize-management">
              Prize Management
            </a>
          </li>
          <li>
            <a
                className="link-item active"
                href="https://bramesaas.atlassian.net/servicedesk/customer/portal/1"
                target="_blank"
                rel="noopener noreferrer"
            >
              Support
            </a>
          </li>
          <li>
            <a
                className="link-item"
                href="#"
                onClick={() => {
                  authService.logout();
                }}
            >
              Sign Out
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
